import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IAdministrativeComplaintView } from 'app/models/mainMenu/mainMenu';
import { ISelectItems } from 'app/models/shared/shared';
import { IAdminEmailView, IRoleEdit, ISaveAdminBusiness, ISaveAdminComplaint, ISaveUserAndRoles, IUserAndRoles } from 'app/models/admin/admin';
import { IBusinessView } from 'app/models/business/business';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({ providedIn: 'root' })
export class AdminService {

  currentBusiness: IBusinessView;
  businessList: IBusinessView[] = [];
  businessAdminSearch: string = '';
  userSearch: string = '';
  complaintId: number = 0;
  currentComplaint: IAdministrativeComplaintView;
  complaintSearch: string = '';

  public api: string = environment.privateApi + 'admin/';

  public apiUser: string = environment.privateApi + 'userAdministration/';

  private http = inject(HttpClient);

  // Email Admin

  getEmailData(): Observable<IAdminEmailView[]> {
    return this.http.get<IAdminEmailView[]>(this.api + 'getEmailData');
  }

  saveEmailAdminData(email: IAdminEmailView): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'saveEmailAdminData', email);
  }

  // Complaint Admin

  getSearchComplaintData(searchText: string): Observable<IAdministrativeComplaintView[]> {
    return this.http.get<IAdministrativeComplaintView[]>(this.api + 'getSearchComplaintData/' + searchText);
  }

  saveComplaintAdmin(complaint: ISaveAdminComplaint): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'saveComplaintAdmin', complaint);
  }

  getNonActionable(): Observable<ISelectItems[]> {
    return this.http.get<ISelectItems[]>(this.api + 'getNonActionable');
  }

  otherBusinessComplaints(businessId: string): Observable<IAdministrativeComplaintView[]> {
    return this.http.get<IAdministrativeComplaintView[]>(this.api + 'otherBusinessComplaints/' + businessId);
  }

  // Business Admin

  getBusinessAdminData(searchText: string): Observable<IBusinessView[]> {
    return this.http.get<IBusinessView[]>(this.api + 'getBusinessAdminData/' + searchText);
  }

  getExemptTypeOptionsList(): Observable<ISelectItems[]> {
    return this.http.get<ISelectItems[]>(this.api + 'getExemptTypeOptionsList');
  }  

  getExemptStatusOptionsList(): Observable<ISelectItems[]> {
    return this.http.get<ISelectItems[]>(this.api + 'getExemptStatusOptionsList');
  }  

  saveBusinessAdmin(business: ISaveAdminBusiness): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'saveBusinessAdmin', business);
  }

  saveNewBusiness(business: ISaveAdminBusiness): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'saveNewBusiness', business);
  }

  saveMerge(mergeFromId: number, mergeToId: number): Observable<boolean> {
    return this.http.get<boolean>(this.api + 'saveMerge/' + mergeFromId + '/' + mergeToId);
  }

  // Roles

  getRoles(): Observable<IRoleEdit[]> {
    return this.http.get<IRoleEdit[]>(this.apiUser + 'getRoles');
  }

  createRole(role: string): Observable<boolean> {
    return this.http.get<boolean>(this.apiUser + 'createRole/' + role);
  }

  saveRole(id: string, newRole: string): Observable<boolean> {
    return this.http.get<boolean>(this.apiUser + 'saveRole/' + id + '/' + newRole);
  }

  deleteRole(id: string, role: string): Observable<boolean> {
    return this.http.get<boolean>(this.apiUser + 'deleteRole/' + id + '/' + role);
  }

  // Users

  getUsersList(type: string, searchText: string): Observable<IUserAndRoles[]> {
    return this.http.get<IUserAndRoles[]>(this.apiUser + 'getUsersList/'+ type + '/' + searchText);
  }

  saveUser(user: ISaveUserAndRoles): Observable<boolean> {
    return this.http.post<boolean>(this.apiUser + 'saveUser', user);
  }

  deleteUser(userId: string): Observable<boolean> {
    return this.http.get<boolean>(this.apiUser + 'deleteUser/' + userId);
  }

}
